let amaModulesCache: any = null;

export default function getModules() {
  const adTags = {
      autoPlay: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/134926372/Seiska.fi/video/autoplay&description_url=__page-url__&url=http%3A%2F%2Fwww.seiska.fi&tfcd=0&npa=0&sz=1080x1920%7C1920x1080&cmsid=2554719&vid=__item-mediaid__&cust_params=pos%3Dauto&gdfp_req=1&ad_rule=1&output=xml_vast4&unviewed_position_start=1&env=vp&impl=s&correlator=__random-number__&vpos=preroll&plcmt=2&vpmute=1&vpa=auto',
      clickToPlay: 'https://pubads.g.doubleclick.net/gampad/ads?iu=/134926372/Seiska.fi/video/clicktoplay&description_url=__page-url__&tfcd=0&npa=0&sz=640x480%7C720x1280%7C1080x1920%7C1920x1080&cmsid=2554719&vid=__item-mediaid__&cust_params=pos%3Dclick&gdfp_req=1&ad_rule=1&output=xml_vast4&unviewed_position_start=1&env=vp&impl=s&correlator=__random-number__&vpos=preroll&plcmt=1&vpmute=0&vpa=click',
    };
  if (amaModulesCache) {
    return amaModulesCache;
  }
  
  amaModulesCache = {
      prebidScript: 'https://micro.rubiconproject.com/prebid/dynamic/13046.js',
      usePlacementObserver: true,
      useObserverWithoutUniqueId: true,
      useLoadDMByAdsLib: true,
      adTags,
      useLimitedAds: true,
      useStats: true,
      useVideoStats: true,
      useGLazyLoad: ['responsive_1', 'top_ad'],
    };
 
  return amaModulesCache;
}
  